import React, { useState, useEffect } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import { InfinitySpin } from "react-loader-spinner";
import { patchUpdateCustomerSMSCheck } from "../../../../../Service";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
// Import the customer action - adjust path based on your actual file structure
import { setCustomerUserData } from "../../../../../reducers/User/action";

export default function Notification() {
  const [accountAddLoader, setAccountAddLoader] = useState(false);
  const [isSmsSend, setIsSmsSend] = useState(false);
  const dispatch = useDispatch();

  // Get customer data from store
  const userData = useSelector((store) => store.user["customeruser"]);

  // Sync local state with Redux whenever userData changes
  useEffect(() => {
    if (userData?.isSmsSend !== undefined) {
      setIsSmsSend(userData.isSmsSend);
    }
  }, [userData?.isSmsSend]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAccountAddLoader(true);

    try {
      // Prepare payload
      const payload = {
        customerId: userData?.id || 0, // Note: customer ID is stored as 'id' in customeruser
        isSmsSend: isSmsSend,
      };

      // Call the API
      const response = await patchUpdateCustomerSMSCheck(payload);
      await handleApiResponse(response);
    } catch (error) {
      console.error("Customer Notification - API Error:", error);
      setAccountAddLoader(false);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Oops...",
        showConfirmButton: false,
        text: "Something went wrong. Please try again.",
        timer: 3000,
      });
    }
  };

  const handleApiResponse = async (response) => {
    if (response.data.statusCode === 200) {
      setAccountAddLoader(false);

      // ✅ Update Redux store using existing customer action
      dispatch(
        setCustomerUserData({
          ...userData,
          isSmsSend: isSmsSend,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "Success!",
        showConfirmButton: false,
        text:
          response.data.statusMessage ||
          "SMS preferences updated successfully!",
        timer: 3000,
      });
    } else {
      setAccountAddLoader(false);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Oops...",
        showConfirmButton: false,
        text: response.data.statusMessage || "Failed to update SMS preferences",
        timer: 3000,
      });
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Form.Group
          as={Col}
          controlId="formCheckSms"
          className="tearmsAndConditions"
        >
          <Form.Check
            type="checkbox"
            checked={isSmsSend}
            id="formCheckSms"
            onChange={(e) => setIsSmsSend(e.target.checked)}
            className={isSmsSend ? "tearmsChecked" : "termsdivition"}
          />
          <Form.Control.Feedback>
            I agree to receive recurring automated promotional and personalized
            marketing text messages from Unext at the mobile number I provided.
            I understand this agreement is voluntary and is not required as a
            condition of purchase. Message frequency may vary and standard
            message/data rates may apply. I may withdraw my agreement at any
            time by unchecking this box in my notification settings.
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row>
        <div style={{ textAlign: "center" }}>
          {accountAddLoader ? (
            <InfinitySpin
              height="80"
              width="200"
              radius="9"
              color="#D49D29"
              ariaLabel="loading"
            />
          ) : (
            <Button variant="primary" className="upload-btn" type="submit">
              Save
            </Button>
          )}
        </div>
      </Row>
    </Form>
  );
}
